export const BUILDINGS_CONSTS = {
    GET_BUILDINGS: "GET_BUILDINGS",
    GET_BUILDING_BY_ID: "GET_BUILDING_BY_ID",
    STATE_FILTER:"STATE_FILTER",

    //Houses Constants
    GET_AREAS: "GET_AREAS",
    GET_AREAS_BEST_OFFER: "GET_AREAS_BEST_OFFER",
    GET_AREAS_MIN_PRICES: "GET_AREAS_MIN_PRICES",
    GET_AREAS_INITIAL_INFO: "GET_AREAS_INITIAL_INFO",
    GET_AREAS_INFO: "GET_AREAS_INFO",
    RESET_AREAS_INFO: "RESET_AREAS_INFO",
    REMOVE_AREAS_LIST: "RESET_AREAS_INFO"
};
